module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BackgroundSlider', [_c('p', [_c('img', {
    attrs: {
      "width": "200",
      "src": require("assets/logo.svg"),
      "alt": _vm.description
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "is-title is-bold",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.name.replace('-', ' ')))]), _vm._v(" "), _c('p', [_c('strong', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Stats Engine")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f07887c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue
// module id = 669
// module chunks = 30